import styled from 'styled-components';

export interface Props {
  children: any;
}

export function TooltipRoot(props: Props) {
  return (
    <Root>
      <Main>{props.children}</Main>
    </Root>
  );
}

export const Root = styled.div`
  max-width: 80vw;
`;

export const Main = styled.div`
  max-width: 40rem;
`;
